
































































import { Component, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { cloneDeep } from 'lodash'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  Alert,
  AlertMessage,
  defaultSystemCode,
  DeleteReserveRequest,
  DeleteReserveRequestReserve,
  ErrorMessage,
  reserveApi,
  SystemCode,
  systemCodeApi
} from '@/api'
import { alertStore, modalErrorStore } from '@/store'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import CODE_KEY from '@/config/code_key'
import { ReserveReceipt } from '@/api/models/reserve/ReserveReceipt'
import { CommandType } from '@/types/websocket'
import { AlertCodeAL300039, ReceiptPrintName } from '@/types'

export interface ModalReserveCancelInterface {
  reserveCancelCollections: ReserveCancelCollection[]
  onReserveCanceled: () => void
}

interface InputItem {
  reason: {
    input: SystemCode
    errorMessage: string
  }
  memo: {
    input: string
    errorMessage: string
  }
  canceler: {
    input: string
    errorMessage: string
  }
}

interface ReserveCancelCollection {
  reserveId: number
  revision: number
}

const defaultInputItem: InputItem = {
  reason: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  memo: {
    input: '',
    errorMessage: ''
  },
  canceler: {
    input: '',
    errorMessage: ''
  }
}

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalReserveCancel extends ComponentVue {
  reserveCancelCollections: ReserveCancelCollection[] = []

  reserveCanceled?: () => void

  dialog: boolean = false

  inputItem: InputItem = cloneDeep(defaultInputItem)

  reserveCancelReasonCodes: SystemCode[] = []

  @Watch('dialog')
  onShowChanged(): void {
    this.clear()
  }

  open(params: ModalReserveCancelInterface): void {
    this.reserveCancelCollections = params.reserveCancelCollections
    this.reserveCanceled = params.onReserveCanceled

    this.dialog = true

    this.fetchReserveCancelReasonCode()
  }

  close(): void {
    this.reserveCancelCollections = []
    this.reserveCanceled = undefined
    this.inputItem = cloneDeep(defaultInputItem)
    this.reserveCancelReasonCodes = []
    this.dialog = false
  }

  onClickOk() {
    this.reserveCancel()
  }

  clear() {
    this.inputItem = cloneDeep(defaultInputItem)
    if (this.reserveCancelReasonCodes.length > 0) {
      this.inputItem.reason.input = this.reserveCancelReasonCodes[0]
    }
  }

  print() {
    const element = document.querySelector('#modal-reserve-cancel')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  async fetchReserveCancelReasonCode() {
    const systemCode = await systemCodeApi.getSystemCodeWithKey(
      CODE_KEY.RESERVE_CANCEL_REASON.KEY
    )

    this.reserveCancelReasonCodes = systemCode.codes
    this.inputItem.reason.input = systemCode.codes[0]
  }

  async reserveCancel(_reserveAssign?: boolean) {
    const request: DeleteReserveRequest = {
      reserves: this.reserveCancelCollections.map(
        (item): DeleteReserveRequestReserve => {
          return {
            id: item.reserveId,
            revision: item.revision,
            _reserveAssign
          }
        }
      ),
      reason: this.inputItem.reason.input.code,
      memo: this.inputItem.memo.input,
      canceler: this.inputItem.canceler.input
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const items: ReserveReceipt[] = await reserveApi.deleteReserve(request)
      items.forEach(item => {
        if (item.receiptInfoReserve !== undefined) {
          this.$webSocket.sendReceiptPrintMessage({
            command: CommandType.ReceiptPrintReserve,
            name: ReceiptPrintName.ReceiptPrintReserve,
            data: item.receiptInfoReserve,
            subject: `利用者番号：${item.receiptInfoReserve.user_id}`
          })
        }
        if (item.receiptInfoReserveForwarding !== undefined) {
          this.$webSocket.sendReceiptPrintMessage({
            command: CommandType.ReceiptPrintReserveForwarding,
            name: ReceiptPrintName.ReceiptPrintReserveForwarding,
            data: item.receiptInfoReserveForwarding,
            subject: `資料番号：${item.receiptInfoReserveForwarding.collection_no}`
          })
        }
      })

      if (this.reserveCanceled) {
        this.reserveCanceled()
      }

      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeAL300039
        ) {
          alertStore.setItem(error.alerts[0])
          this.$modalAlert.open({
            onOkClick: () => {
              this.reserveCancel(true)
            },
            onCancelClick: () => {
              this.reserveCancel(false)
            }
          })
          return
        }
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  setErrorMessage(alerts: Alert[]) {
    alerts.forEach(alert => {
      switch (alert.attribute) {
        case 'reason':
          this.inputItem.reason.errorMessage = alert.message
          break
        case 'memo':
          this.inputItem.memo.errorMessage = alert.message
          break
        case 'canceler':
          this.inputItem.canceler.errorMessage = alert.message
          break
      }
    })
  }
}
